// extracted by mini-css-extract-plugin
export default {"loadable-content-loader":"LoadableContent_loadable-content-loader__bf8vk","loadable-content-error-message":"LoadableContent_loadable-content-error-message__Jt5nS"};